import PersonalOffersStore from '../stores/PersonalOffersStore';
import ProposalStore from '../stores/ProposalStore';
import SsoStore from '../stores/SsoStore';
import { FetchStatus } from '../util/FetchStatus';
import RouteStore from '../stores/RouteStore';

export enum OfferType {
  DISCOUNT = 'DISCOUNT',
  DEFAULT = 'DEFAULT',
}

export interface DataContainer<T> {
  status: FetchStatus;
  data: T;
}

export interface B2BOffer {
  offerIds: number[];
  offerInternet: boolean;
  offerMobile: boolean;
  loyalty: boolean;
  discountCodeOfferId: number;
}

export interface Offer {
  id: number;
  title: string;
  content?: string;
  excerpt: string;
  url?: string;
  image: string;
  mobileImage?: string;
  slug?: string;
  ctaLabel?: string;
  modal?: boolean;
  offerType: OfferType;
  salesCampaignId?: number;
  displayed?: boolean;
  presented?: boolean;
  tagContent?: string;
  recommendationItemId?: number;
  priority?: 0 | 1 | 2 | 3 | 4 | 5;
  rejectable?: boolean;
}

export interface MobileRecommendationsProps {
  proposalStore?: ProposalStore;
  routeStore?: RouteStore;
  ssoStore?: SsoStore;
}

export interface ProposalModalProps {
  proposalStore?: ProposalStore;
  personalOffersStore?: PersonalOffersStore;
  initialState?: InitialState;
  isModal?: boolean;
  noRecommendationsContent?: JSX.Element;
}

export interface OfferActions {
  reject?: (offer: Offer) => void;
  present: (offer: Offer) => void;
  accept: (recommendationItemId: number) => void;
}
